<template>
  <basepage
    title="Amadeus Aktarımı (sftp)"
    :status="status"
    :menuitems="menuItems"
    v-on:menuclick="menuClick"
  >
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <template slot="toolbar">
      <!--
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    -->
    </template>

    <v-layout v-if="StatusUI.buttonBaslat">
      <v-flex xs12 sm12 md12>
        <v-card flat>
          <v-layout row wrap justify-space-between align-center>
            <v-flex xs12 sm3 md3>
              <v-btn
                :disabled="status.loading || !StatusUI.buttonBaslat"
                color="info"
                @click="edfeterexport()"
                >{{$t('Transfer-pending-files')}}</v-btn
              >
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-btn
                color="info"
                @click="TaskBiletList(100)"
                :disabled="status.loading"
              >
               {{this.$t('List-the-Last-1000-Tickets-Transferred')}}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm4 md6>
              <div v-if="StatusUI.hataOlustu">
                {{ $t("Error") }} : {{ StatusUI.aciklama }}
                <code>
                  {{ StatusUI.hataMesaji }}
                </code>
              </div>
              <div v-else>
                <div>
                  {{ StatusUI.aciklama }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonYenile">
      <v-flex xs12 sm12 md12>
        <v-card flat>
          <v-layout row wrap justify-space-between align-center>
            <v-flex xs12 sm3 md3>
              <v-btn
                :disabled="status.loading || !StatusUI.buttonYenile"
                color="info"
                @click="yenile(10)"
                >({{ countDown }}) Yenile</v-btn
              >
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-btn
                :disabled="status.loading || !StatusUI.buttonYenile"
                color="info"
                @click="sonlandir()"
              >
                {{ $t("Terminate") }}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <div>
                <h3 class="headline mb-0">Dosyalar Aktarılıyor</h3>

                <!--   <div> {{ $t('Commencement-Period') }}  : {{ StatusUI.parametre.Tarih1 }}</div>
              <div> {{ $t('Termination-Period') }}  : {{ StatusUI.parametre.Tarih2 }}</div> -->

                <div>{{ StatusUI.aciklama }}</div>

                <div></div>
                <v-progress-linear color="green" v-model="yuzde" height="25">
                  <strong>{{ Math.ceil(yuzde) }}%</strong>
                </v-progress-linear>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonIndir">
      <v-flex xs12 sm12 md12>
        <v-card flat>
          <v-layout row wrap justify-space-between align-center>
            <v-flex xs12 sm3 md3>
              <v-btn
                :disabled="status.loading || !StatusUI.buttonIndir"
                color="info"
                @click="sil()"
                >{{ $t("New") }}</v-btn
              >
            </v-flex>
            <v-flex xs12 sm9 md9>
              <div>
                <h3 class="headline mb-0">Dosyalar Aktarıldı</h3>
                <!--    <div> {{ $t('Commencement-Period') }}  : {{ StatusUI.parametre.Tarih1 }}</div>
              <div> {{ $t('Termination-Period') }} : {{ StatusUI.parametre.Tarih2 }}</div> -->

                <div>
                  Aktarılan Dosya Sayısı :
                  {{ StatusUI.sonuc.KaydedilenMIRDosyaSayisi }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <br />
    <v-layout row wrap>
      <v-flex xs12 sm5 md5>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title>{{ $t("Transferred-Tickets") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            flat=""
            solo-inverted=""
            hide-details
            v-model="search3"
            :label="$t('Search')"
            append-icon="search"
          >
          </v-text-field>
        </v-toolbar>

        <v-card>
          <v-data-table
            :headers="headers"
            :rows-per-page-items="[20, 500]"
            :items="itemsok"
            :search="search3"
          >
            <template slot="items" slot-scope="props">
              <tr item>
                <td class="text-xs-left">{{ props.item.biletNo }}</td>
                <td class="text-xs-left">{{ props.item.aciklama }}</td>
                <td>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="git(props.item)"
                    :disabled="status.loading"
                  >
                    <v-icon color="teal">search</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="AmadeusAirFileDownload(props.item)"
                    :disabled="status.loading"
                  >
                    <v-icon color="teal">file_download</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              {{ $t("No-records-searched-for", { value: search3 }) }}
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 sm7 md7>
        <v-toolbar size="120px" dark color="red">
          <v-toolbar-title>{{ $t("Tickets-Not-Transferred") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            flat=""
            solo-inverted=""
            hide-details
            v-model="search4"
            :label="$t('Search')"
            append-icon="search"
          >
          </v-text-field>
        </v-toolbar>
        <v-card>
          <v-data-table
            :headers="headers"
            :rows-per-page-items="[20, 500]"
            :items="itemsno"
            :search="search4"
          >
            <template slot="items" slot-scope="props">
              <tr item>
                <td class="text-xs-left">{{ props.item.biletNo }}</td>
                <td class="text-xs-left">{{ props.item.aciklama }}</td>
                <td>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="git(props.item)"
                    :disabled="status.loading"
                  >
                    <v-icon color="teal">search</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="AmadeusDosyasiniGeriKopyala(props.item)"
                    :disabled="status.loading"
                  >
                    <v-icon color="teal">replay</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="AmadeusAirFileDownload(props.item)"
                    :disabled="status.loading"
                  >
                    <v-icon color="teal">file_download</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              {{ $t("No-records-searched-for", { value: search4 }) }}
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </basepage>
</template>

<script>
import auth from "@/api/auth.js";
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "@/components/app/coper/tools.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  components: {
    basepage,
    tarihcomp,
    yetkidialog
  },
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      status: tool.NewSatatus(),
      countDown: 10,
      MaxCountDown: 10,

      StatusUI: {
        buttonIndir: false,
        buttonBaslat: false,
        buttonYenile: false,
        TblTask: {},
      },

      yuzde: 0,
      prm: {
        Tarih1: tool.Now_yyyy_MM_dd(),
        Tarih2: tool.Now_yyyy_MM_dd(),
        Sonlandir: false,
      },
      response: [],

      aranacak: "",
      menuItems: [
        {
          title: "....",
        },
      ],
      headers: [
        {
          text: this.$t("Ticket-No"),
          value: "biletNo",
        },
        {
          text: this.$t("Status"),
          value: "aciklama",
        },
        {
          text: "İşlem",
          value: "islem",
          sortable: false,
        },
      ],
      itemsno: [],
      itemsok: [],
      search3: "",
      search4: "",
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  methods: {
    countDownTimer() {
      setTimeout(() => {
        if (
          this.StatusUI.buttonYenile == true &&
          this.status.loading == false
        ) {
          this.countDown -= 1;
          if (this.countDown <= 0) {
            this.MaxCountDown++;
            this.countDown = this.MaxCountDown;
            this.yenile(10);
          }
        }
        this.countDownTimer();
      }, 1000);
    },
    menuClick(index) {
      if (index == 0) {
        //TODO : Entegratör Ayar sayfası açılacak
      }
    },
    kayitgetir() {},
    edfeterexport: edfeterexport,
    sonlandir: sonlandir,

    sil: sil,
    dosyaIndir: dosyaIndir,
    yenile: yenile,
    TaskBiletList: TaskBiletList,
    BiletDoldur: BiletDoldur,
    git: git,
    AmadeusDosyasiniGeriKopyala: AmadeusDosyasiniGeriKopyala,
    AmadeusAirFileDownload: AmadeusAirFileDownload,
  },

  beforeMount: beforeMount,
};

function beforeMount() {
  this.yenile(10);
  this.countDownTimer();
}

function yenile(milisaniye) {
  this.countDown = this.MaxCountDown;
  this.status.loading = true;
  setTimeout(() => {
    var prm = {};
    tool.api_post(this, "ArkmanTicketStream/AmadeusFtpStreamStatus", prm).then(
      (response) => {
        this.StatusUI = response.body.data;

        if (response.body.data.TblTask != null) {
          this.yuzde = response.body.data.TblTask.Value;
        }
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
}

function git(v) {
  if (v.biletNo.length == 13) {
    var str = v.biletNo.slice(3);
  } else {
    var str = v.biletNo;
  }

  var url =
    "#/bilet/yeni/id?" +
    "isl=get&hyolukod=" +
    v.bilet.HavayoluKodu +
    "&biletno=" +
    str +
    "&ucustipi=" +
    v.bilet.UcusTipi;

  window.open(url, "_blank");
}

function BiletDoldur(val) {
  this.itemsok = [];
  this.itemsno = [];

  if (val) {
    val.forEach((element) => {
      if (element.basarili) {
        this.itemsok.push(element);
        //aktarilan = aktarilan + 1
      } else {
        this.itemsno.push(element);
      }
    });
  }
}

function TaskBiletList(milisaniye) {
  this.status.loading = true;
  setTimeout(() => {
    var prm = {};
    tool.api_post(this, "ArkmanTicketStream/TaskBiletList", prm).then(
      (response) => {
        this.BiletDoldur(response.body.data);
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
}

function AmadeusAirFileDownload(item) {
  this.status.loading = true;

  let params = {
    FileId: item.info.BiletFile_id,
  };

  let credentials = JSON.parse(window.localStorage.getItem("credentials"));

  this.$http
    .post(
      auth.API_URL + "api/ArkmanTicketStream/AmadeusAirFileDownload",
      params,
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          CariSirketNo: credentials.SirketKodu.toString(),
          CoperSirketNo: credentials.CoperSirketNo.toString(),
          MuhasebeSirketNo: credentials.MuhasebeSirketNo.toString(),
        },
      }
    )
    .then(
      (response) => {
        this.status.loading = false;
        var blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "AMADEUS" + item.info.BiletFile_id + ".AIR";
        link.click();
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
}

function AmadeusDosyasiniGeriKopyala(item) {
  this.status.loading = true;
  setTimeout(() => {
    var prm = {
      FileId: item.info.BiletFile_id,
    };
    tool
      .api_post(this, "ArkmanTicketStream/AmadeusDosyasiniGeriKopyala", prm)
      .then(
        (response) => {
          if (response.body.Status == true) {
            this.status.loading = false;
            this.TaskBiletList(10);
          } else {
            this.status.loading = false;
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
  }, 300);
}

function edfeterexport() {
  let prm = this.prm;
  prm.Sonlandir = false;
  prm.Sil = false;

  this.status.loading = true;
  tool.api_post(this, "ArkmanTicketStream/AmadeusFtpStream", prm).then(
    (response) => {
      this.response = response.body;

      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
        //this.yuzde = 0;

        this.MaxCountDown = 10;
        this.yenile(5000);
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;

        if (response.body.TaskInfo != null) {
          if (response.body.TaskInfo.Status == 2) {
            //Devam ediyor
            this.yuzde = response.body.TaskInfo.Value;
          }
          if (response.body.TaskInfo.Status == 3) {
            //Tamamlandı
            this.yuzde = response.body.TaskInfo.Value;
          }
        }
        this.status.loading = false;
      }
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function sonlandir() {
  let prm = this.prm;
  prm.Sonlandir = true;
  prm.Sil = false;

  this.status.loading = true;
  tool.api_post(this, "ArkmanTicketStream/AmadeusFtpStream", prm).then(
    (response) => {
      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
      this.status.loading = false;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function dosyaIndir() {
  var prm = {};

  this.status.loading = true;
  setTimeout(() => {
    tool.api_post_FileDownload(this, "EDefter/EDefterDosyaIndir", prm).then(
      (response) => {
        tool.CreateDownloadLink(response, "edefter");
        this.status.text = "Dosya İndiriliyor";
        this.status.show = true;
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 5000);
}

function sil() {
  let prm = this.prm;
  prm.Sonlandir = false;
  prm.Sil = true;

  this.status.loading = true;
  tool.api_post(this, "ArkmanTicketStream/AmadeusFtpStream", prm).then(
    (response) => {
      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
      this.status.loading = false;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>
